<svg [style.transform]="'rotate('+rotation()+'deg)'" [style.opacity]="opacity()" [attr.width]="size()" [attr.height]="size()"
     viewBox="22 5 250 250" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0)" [attr.stroke-width]="strokeWidth()">
    <path d="M43.5955 132.095L239.595 132.095" [attr.stroke]="'url(#paint0-'+color()+')'"/>
    <path d="M92.5955 47.2249L190.595 216.966" [attr.stroke]="'url(#paint1-'+color()+')'"/>
    <path d="M190.595 47.2249L92.5954 216.966" [attr.stroke]="'url(#paint2-'+color()+')'"/>
    <path d="M97.4282 158.095L122.115 132.595L97.4282 107.095L131.855 115.725L141.595 81.5954L151.336 115.725L185.763 107.095L161.076 132.595L185.763 158.095L151.336 149.466L141.595 183.595L131.855 149.466L97.4282 158.095Z"
          [attr.stroke]="'url(#paint3-'+color()+')'"/>
    <path d="M141.595 81.5955L151.336 115.725L185.763 107.095L161.076 132.595L185.763 158.095L151.336 149.466L141.595 183.595L131.855 149.466L97.4282 158.095L122.115 132.595L97.4282 107.095L131.855 115.725L141.595 81.5955Z"
          [attr.stroke]="'url(#paint4-'+color()+')'"/>
    <path d="M185.763 158.096L151.336 149.466L141.595 183.596L131.855 149.466L97.4282 158.096L122.115 132.596L97.4282 107.096L131.855 115.725L141.595 81.5955L151.336 115.725L185.763 107.096L161.076 132.596L185.763 158.096Z"
          [attr.stroke]="'url(#paint5-'+color()+')'"/>
    <path d="M58.9461 180.313L105.142 132.595L58.9461 84.8778L123.369 101.026L141.595 37.1602L159.822 101.026L224.245 84.8778L178.048 132.595L224.245 180.313L159.822 164.165L141.595 228.031L123.369 164.165L58.9461 180.313Z"
          [attr.stroke]="'url(#paint6-'+color()+')'"/>
    <path d="M141.595 37.1602L159.822 101.026L224.245 84.8778L178.049 132.595L224.245 180.313L159.822 164.165L141.595 228.031L123.369 164.165L58.9461 180.313L105.142 132.595L58.9461 84.8778L123.369 101.026L141.595 37.1602Z"
          [attr.stroke]="'url(#paint7-'+color()+')'"/>
    <path d="M224.245 180.313L159.822 164.165L141.595 228.031L123.369 164.165L58.9461 180.313L105.142 132.596L58.9461 84.8779L123.369 101.026L141.595 37.1603L159.822 101.026L224.245 84.8779L178.048 132.596L224.245 180.313Z"
          [attr.stroke]="'url(#paint8-'+color()+')'"/>
    <path d="M42.9519 189.547L98.0881 132.595L42.9519 75.6436L119.842 94.917L141.595 18.6917L163.349 94.917L240.239 75.6435L185.103 132.595L240.239 189.547L163.349 170.274L141.595 246.499L119.842 170.274L42.9519 189.547Z"
          [attr.stroke]="'url(#paint9-'+color()+')'"/>
    <path d="M141.595 18.6917L163.349 94.9169L240.239 75.6435L185.103 132.595L240.239 189.547L163.349 170.274L141.595 246.499L119.842 170.274L42.9519 189.547L98.0881 132.595L42.9519 75.6435L119.842 94.9169L141.595 18.6917Z"
          [attr.stroke]="'url(#paint10-'+color()+')'"/>
    <path d="M240.239 189.547L163.349 170.274L141.595 246.499L119.842 170.274L42.9519 189.547L98.0881 132.595L42.9519 75.6436L119.842 94.917L141.595 18.6917L163.349 94.917L240.239 75.6436L185.103 132.595L240.239 189.547Z"
          [attr.stroke]="'url(#paint11-'+color()+')'"/>
    <path d="M53.2731 149.595L70.9508 131.918L53.2731 114.24" [attr.stroke]="'url(#paint12-'+color()+')'"/>
    <path d="M81.9638 64.5464L106.112 71.0169L112.582 46.8687" [attr.stroke]="'url(#paint13-'+color()+')'"/>
    <path d="M169.964 46.8687L176.434 71.0168L200.582 64.5463" [attr.stroke]="'url(#paint14-'+color()+')'"/>
    <path d="M229.273 114.24L211.595 131.918L229.273 149.595" [attr.stroke]="'url(#paint15-'+color()+')'"/>
    <path d="M200.582 199.289L176.434 192.819L169.964 216.967" [attr.stroke]="'url(#paint16-'+color()+')'"/>
    <path d="M112.582 216.967L106.112 192.819L81.9638 199.289" [attr.stroke]="'url(#paint17-'+ color() +')'"/>
    <path [attr.fill]="color()"
          d="M165.08 89.436L165.52 90.6105L164.436 91.2416L165.611 90.801L166.242 91.8851L165.801 90.7106L166.885 90.0795L165.711 90.5201L165.08 89.436Z">
      <animate attributeName="d" dur="4s" repeatCount="indefinite" values="
			M165.08 89.436L165.52 90.6105L164.436 91.2416L165.611 90.801L166.242 91.8851L165.801 90.7106L166.885 90.0795L165.711 90.5201L165.08 89.436Z;
			M173 98L166.802 90.6607L173 83.3214L165.661 89.519L158.321 83.3214L164.519 90.6607L158.321 98L165.661 91.8024L173 98Z;
			M164.514 90.9678L165.595 90.7737L165.968 91.8072L165.774 90.7259L166.807 90.3534L165.726 90.5475L165.353 89.5141L165.548 90.5953L164.514 90.9678Z;
			M165.08 89.436L165.52 90.6105L164.436 91.2416L165.611 90.801L166.242 91.8851L165.801 90.7106L166.885 90.0795L165.711 90.5201L165.08 89.436Z;
			M165.08 89.436L165.52 90.6105L164.436 91.2416L165.611 90.801L166.242 91.8851L165.801 90.7106L166.885 90.0795L165.711 90.5201L165.08 89.436Z
		" keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1" calcMode="spline"/>
    </path>
    <path [attr.fill]="color()"
          d="M185.225 193.581L185.665 194.756L184.581 195.387L185.756 194.946L186.387 196.03L185.946 194.856L187.03 194.225L185.856 194.665L185.225 193.581Z">
      <animate attributeName="d" dur="4s" repeatCount="indefinite" values="
			M185.225 193.581L185.665 194.756L184.581 195.387L185.756 194.946L186.387 196.03L185.946 194.856L187.03 194.225L185.856 194.665L185.225 193.581Z;
			M185.225 193.581L185.665 194.756L184.581 195.387L185.756 194.946L186.387 196.03L185.946 194.856L187.03 194.225L185.856 194.665L185.225 193.581Z;
			M191.067 185.692L185.506 193.687L176.691 189.544L184.687 195.105L180.544 203.92L186.105 195.924L194.919 200.068L186.924 194.506L191.067 185.692Z;
			M186.573 195.012L185.849 194.882L185.6 195.574L185.73 194.85L185.037 194.6L185.762 194.73L186.011 194.038L185.881 194.762L186.573 195.012Z;
			M185.225 193.581L185.665 194.756L184.581 195.387L185.756 194.946L186.387 196.03L185.946 194.856L187.03 194.225L185.856 194.665L185.225 193.581Z

		" keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1" calcMode="spline"/>
    </path>
    <path [attr.fill]="color()"
          d="M97.2246 106.581L97.6652 107.756L96.581 108.387L97.7556 107.946L98.3867 109.03L97.9461 107.856L99.0302 107.225L97.8557 107.665L97.2246 106.581Z">
      <animate attributeName="d" dur="4s" repeatCount="indefinite" values="
			M97.2246 106.581L97.6652 107.756L96.581 108.387L97.7556 107.946L98.3867 109.03L97.9461 107.856L99.0302 107.225L97.8557 107.665L97.2246 106.581Z;
			M97.2247 106.581L97.6653 107.756L96.5811 108.387L97.7556 107.946L98.3867 109.03L97.9461 107.856L99.0303 107.225L97.8558 107.665L97.2247 106.581Z;
			M108.19 105.023L98.397 106.781L95.0231 97.421L96.7815 107.214L87.421 110.588L97.2143 108.83L100.588 118.19L98.8298 108.397L108.19 105.023Z;
			M97.5243 106.755L97.8656 107.702L98.8561 107.524L97.9094 107.866L98.0872 108.856L97.746 107.909L96.7554 108.087L97.7022 107.746L97.5243 106.755Z;
			M97.2246 106.581L97.6652 107.756L96.581 108.387L97.7556 107.946L98.3867 109.03L97.9461 107.856L99.0302 107.225L97.8557 107.665L97.2246 106.581Z
		" keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1" calcMode="spline"/>
    </path>
    <path [attr.fill]="color()"
          d="M64.2246 172.581L64.6652 173.756L63.581 174.387L64.7556 173.946L65.3867 175.03L64.9461 173.856L66.0302 173.225L64.8557 173.665L64.2246 172.581Z">
      <animate attributeName="d" dur="4s" repeatCount="indefinite" values="
			M64.2246 172.581L64.6652 173.756L63.581 174.387L64.7556 173.946L65.3867 175.03L64.9461 173.856L66.0302 173.225L64.8557 173.665L64.2246 172.581Z;
			M69.3543 181.684L65.7722 174.065L72.6842 169.257L65.0646 172.839L60.2568 165.927L63.8389 173.547L56.9269 178.354L64.5465 174.772L69.3543 181.684Z;
			M63.2511 174.703L64.6147 173.755L63.908 172.251L64.8565 173.615L66.3597 172.908L64.9961 173.857L65.7027 175.36L64.7543 173.996L63.2511 174.703Z;
			M64.2245 172.581L64.6651 173.756L63.581 174.387L64.7555 173.946L65.3866 175.03L64.946 173.856L66.0301 173.225L64.8556 173.665L64.2245 172.581Z;
			M64.2246 172.581L64.6652 173.756L63.581 174.387L64.7556 173.946L65.3867 175.03L64.9461 173.856L66.0302 173.225L64.8557 173.665L64.2246 172.581Z
		" keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1" calcMode="spline"/>
    </path>
  </g>
  <defs>
    <linearGradient id="paint0-#FFFFFF" x1="37.6211" y1="133.375" x2="236.528" y2="129.858"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint1-#FFFFFF" x1="88.5002" y1="42.6907" x2="191" y2="213.191" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0">
        <animate attributeName="stop-opacity" dur="4s" repeatCount="indefinite" values="0;0;1;0;0"
                 keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
                 calcMode="spline"/>
      </stop>
    </linearGradient>
    <linearGradient id="paint2-#FFFFFF" x1="192.475" y1="41.4112" x2="96.0671" y2="215.429"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0">
        <animate attributeName="stop-opacity" dur="4s" repeatCount="indefinite" values="0;1;0;0;0"
                 keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
                 calcMode="spline"/>
      </stop>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint3-#FFFFFF" x1="146.529" y1="257.4" x2="215.881" y2="264.029" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint4-#FFFFFF" x1="31.0448" y1="74.4652" x2="-9.37195" y2="131.212"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint5-#FFFFFF" x1="247.213" y1="65.921" x2="218.277" y2="2.54559" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint6-#FFFFFF" x1="150.827" y1="366.14" x2="280.605" y2="378.544" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint7-#FFFFFF" x1="-65.2757" y1="23.8174" x2="-140.907" y2="130.007"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint8-#FFFFFF" x1="339.236" y1="7.8288" x2="285.088" y2="-110.764"
                    gradientUnits="userSpaceOnUse">
      <animate attributeName="x1" dur="4s" repeatCount="indefinite" values="339.236;333.444;339.244;339.236;339.236"
               keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
               calcMode="spline"/>
      <animate attributeName="y1" dur="4s" repeatCount="indefinite" values="7.8288;293.491;7.82434;7.8288;7.8288"
               keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
               calcMode="spline"/>
      <animate attributeName="x2" dur="4s" repeatCount="indefinite" values="285.088;355.842;276.932;285.088;285.088"
               keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
               calcMode="spline"/>
      <animate attributeName="y2" dur="4s" repeatCount="indefinite" values="-110.764;154.456;-109.907;-110.764;-110.764"
               keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
               calcMode="spline"/>
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint9-#FFFFFF" x1="152.613" y1="411.336" x2="307.506" y2="426.14" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint10-#FFFFFF" x1="-105.309" y1="2.76687" x2="-195.576" y2="129.506"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint11-#FFFFFF" x1="377.483" y1="-16.316" x2="312.857" y2="-157.859"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint12-#FFFFFF" x1="56.2237" y1="173.776" x2="76.23" y2="173.157" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint13-#FFFFFF" x1="62.4983" y1="79.1918" x2="73.0372" y2="96.2084"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint14-#FFFFFF" x1="147.548" y1="37.3338" x2="138.08" y2="54.969" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint15-#FFFFFF" x1="226.323" y1="90.0596" x2="206.316" y2="90.6783"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint16-#FFFFFF" x1="220.048" y1="184.644" x2="209.509" y2="167.627"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint17-#FFFFFF" x1="134.999" y1="226.502" x2="144.466" y2="208.866"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFFFFF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#FFFFFF"/>
      <stop offset="1" stop-color="#FFFFFF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint0-#9747FF" x1="37.6211" y1="133.375" x2="236.528" y2="129.858"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint1-#9747FF" x1="88.5002" y1="42.6907" x2="191" y2="213.191" gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0">
        <animate attributeName="stop-opacity" dur="4s" repeatCount="indefinite" values="0;0;1;0;0"
                 keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
                 calcMode="spline"/>
      </stop>
    </linearGradient>
    <linearGradient id="paint2-#9747FF" x1="192.475" y1="41.4112" x2="96.0671" y2="215.429"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0">
        <animate attributeName="stop-opacity" dur="4s" repeatCount="indefinite" values="0;1;0;0;0"
                 keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
                 calcMode="spline"/>
      </stop>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint3-#9747FF" x1="146.529" y1="257.4" x2="215.881" y2="264.029" gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint4-#9747FF" x1="31.0448" y1="74.4652" x2="-9.37195" y2="131.212"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint5-#9747FF" x1="247.213" y1="65.921" x2="218.277" y2="2.54559"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint6-#9747FF" x1="150.827" y1="366.14" x2="280.605" y2="378.544"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint7-#9747FF" x1="-65.2757" y1="23.8174" x2="-140.907" y2="130.007"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint8-#9747FF" x1="339.236" y1="7.8288" x2="285.088" y2="-110.764"
                    gradientUnits="userSpaceOnUse">
      <animate attributeName="x1" dur="4s" repeatCount="indefinite" values="339.236;333.444;339.244;339.236;339.236"
               keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
               calcMode="spline"/>
      <animate attributeName="y1" dur="4s" repeatCount="indefinite" values="7.8288;293.491;7.82434;7.8288;7.8288"
               keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
               calcMode="spline"/>
      <animate attributeName="x2" dur="4s" repeatCount="indefinite" values="285.088;355.842;276.932;285.088;285.088"
               keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
               calcMode="spline"/>
      <animate attributeName="y2" dur="4s" repeatCount="indefinite" values="-110.764;154.456;-109.907;-110.764;-110.764"
               keyTimes="0;0.25;0.5;0.75;1" keySplines="0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1; 0.42 0 1 1"
               calcMode="spline"/>
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint9-#9747FF" x1="152.613" y1="411.336" x2="307.506" y2="426.14"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint10-#9747FF" x1="-105.309" y1="2.76687" x2="-195.576" y2="129.506"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint11-#9747FF" x1="377.483" y1="-16.316" x2="312.857" y2="-157.859"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint12-#9747FF" x1="56.2237" y1="173.776" x2="76.23" y2="173.157"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint13-#9747FF" x1="62.4983" y1="79.1918" x2="73.0372" y2="96.2084"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint14-#9747FF" x1="147.548" y1="37.3338" x2="138.08" y2="54.969"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint15-#9747FF" x1="226.323" y1="90.0596" x2="206.316" y2="90.6783"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint16-#9747FF" x1="220.048" y1="184.644" x2="209.509" y2="167.627"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <linearGradient id="paint17-#9747FF" x1="134.999" y1="226.502" x2="144.466" y2="208.866"
                    gradientUnits="userSpaceOnUse">
      <stop stop-color="#9747FF" stop-opacity="0"/>
      <stop offset="0.45" stop-color="#9747FF"/>
      <stop offset="1" stop-color="#9747FF" stop-opacity="0"/>
    </linearGradient>
    <clipPath id="clip0">
      <rect width="291" height="258" fill="#FFFFFF"/>
    </clipPath>
  </defs>
</svg>

